<mat-card class="mb-25 tagus-card" [class.component-rtl-enabled]="themeService.isRTLEnabled()">
    <mat-card-content class="card-content">

        <mat-accordion [togglePosition]="'before'" class="mail-sidebar-accordion">
            <ng-container *ngFor="let sidebar of domain_sidebar; index as i">
                <div class="bg-gray-100 py-2 px-2 w-100 text-left" *ngIf="domain_sidebar.length === 1">
                    <h6>
                        {{ sidebar?.username | slice : 0 : 30 }}
                    </h6>
                </div>

                <mat-expansion-panel (opened)="toggleMailPanel(true, sidebar, i)"
                    (closed)="toggleMailPanel(false, sidebar, i)" [expanded]="
                    domain_sidebar.length > 1
                        ? selected_domain_index === i
                        : true
                ">
                    <mat-expansion-panel-header *ngIf="domain_sidebar.length > 1">
                        <mat-panel-title>
                            <span class="title">
                                <!-- {{sidebar?.domain}} - -->
                                <span [matTooltip]="
                                        sidebar?.mail?.length > 25
                                            ? sidebar?.mail
                                            : sidebar?.mail
                                    ">
                                    {{ sidebar?.username | slice : 0 : 30 }}
                                    <!-- <span *ngIf="sidebar?.mail?.length > 30">...</span> -->
                                </span>
                            </span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ul class="email-sidebar ps-0 list-unstyled mb-0">
                        <ng-container *ngFor="let menus of sidebar?.sub_menus">
                            <li class="position-relative">
                                <i class="{{ menus?.icon }}"></i>
                                <a href="javascript:void(0)" (click)=" setMailType(i); loadMail(menus, sidebar);"
                                    class="fw-semibold position-relative d-block"  [ngClass]="{
                                        'gray-color':
                                            menus.id === selected_menu.id &&
                                            selected_domain?.mail ===
                                                sidebar.mail
                                    }">
                                    {{ menus.menu }}
                                    <!-- <span class="d-block">{{
                                        menus.count > 0 ? menus.count : ""
                                    }}</span> -->
                                    <span class="d-block">{{
                                        menus.count > 0 ? menus.count : ""
                                        }}</span>
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                    <ng-container *ngIf="false">
                        <span class="sub-title d-flex muted-color fw-normal fs-14 justify-content-space-between"
                            *ngIf="!sidebar?.isGlobalMail">
                            FOLDERS
                            <i class="ri-add-circle-line pt-2 fs-16 main-color cursor-pointer"
                                matTooltip="Create folder" (click)="createFolder(sidebar.domain, sidebar.mail)"></i>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="false">
                        <span class="sub-title d-flex muted-color fw-normal fs-14 justify-content-space-between"
                            *ngIf="!sidebar?.isGlobalMail">
                            CUSTOME FOLDERS
                        </span>
                    </ng-container>
                    <ul class="email-sidebar ps-0 list-unstyled mb-0 folder-menus">
                        <ng-container *ngIf="
                                show_folder_input &&
                                folder_action_type === 'add'
                            ">
                            <ng-container *ngTemplateOutlet="
                                    folderInputTemplate;
                                    context: { sidebar: sidebar }
                                "></ng-container>
                        </ng-container>
                        <!-- <li
                            class="position-relative"
                            *ngIf="
                                show_folder_input &&
                                sidebar.domain === selected_folder_domain
                            "
                        >
                            <ng-container>
                                <input
                                    type="text"
                                    class="form-control folder-input"
                                    [(ngModel)]="folder_name"
                                />
                                <button
                                    mat-button
                                    color="primary"
                                    class="save-fold-btn"
                                    (click)="submitFolder(sidebar.domain, sidebar.mail)"
                                    [disabled]="!folder_name"
                                >
                                    {{
                                        folder_action_type === "add"
                                            ? "Save"
                                            : "Update"
                                    }}
                                </button>
                                <button
                                    mat-button
                                    color="warn"
                                    class="save-fold-btn"
                                    (click)="
                                        show_folder_input = false;
                                        folder_name = '';
                                        selected_folder_domain = ''
                                    "
                                >
                                    Cancel
                                </button>
                            </ng-container>
                        </li> -->

                        <ng-template #folderInputTemplate let-sidebar="sidebar">
                            <li class="position-relative p-0">
                                <input type="text" class="form-control folder-input" [(ngModel)]="folder_name"
                                    placeholder="Enter folder name" />
                                <button mat-button color="primary" class="save-fold-btn" (click)="
                                        submitFolder(
                                            sidebar.domain,
                                            sidebar.mail
                                        )
                                    " [disabled]="!folder_name">
                                    {{
                                    folder_action_type === "add"
                                    ? "Save"
                                    : "Update"
                                    }}
                                </button>
                                <button mat-button color="warn" class="save-fold-btn" (click)="
                                        show_folder_input = false;
                                        folder_name = '';
                                        selected_folder_domain = ''
                                    ">
                                    Cancel
                                </button>
                            </li>
                        </ng-template>

                        <ng-container *ngIf="sidebar && sidebar?.totalFolderCount?.length">
                            <li class="position-relative" *ngFor="
                                    let folder of sidebar?.totalFolderCount;
                                    index as j
                                ">
                                <!-- Edit Folder -->
                                <ng-container *ngIf="
                                        show_folder_input &&
                                            folder_action_type === 'edit' &&
                                            selected_folder_id === folder.id;
                                        else folderDisplayTemplate
                                    ">
                                    <div class="d-flex align-items-center" *ngIf="false">
                                        <i class="ri-folder-line"></i>
                                        <ng-container *ngTemplateOutlet="
                                                folderInputTemplate;
                                                context: { sidebar: sidebar }
                                            "></ng-container>
                                    </div>
                                </ng-container>

                                <!-- Display Folder -->
                                <ng-template #folderDisplayTemplate>
                                    <i class="ri-folder-line"></i>
                                    <a href="javascript:void(0)" class="fw-semibold position-relative d-block"
                                        routerLinkActive="active" [ngClass]="{
                                            'gray-color':
                                                folder.id ===
                                                    selected_menu.id &&
                                                selected_domain?.mail ===
                                                    sidebar.mail
                                        }">
                                        <div (click)="
                                                loadMail(folder, sidebar, 'folder');
                                                $event.stopPropagation()
                                            ">
                                            {{ folder?.name }}
                                        </div>
                                        <span class="d-block folder-count">{{
                                            folder.count > 0 ? folder.count : ""
                                            }}</span>

                                        <span *ngIf="false" class="d-block edit-icon" (click)="
                                                editFolder(
                                                    j,
                                                    sidebar.domain,
                                                    folder
                                                );
                                                $event.stopPropagation()
                                            ">
                                            <i class="ri-pencil-line"></i>
                                        </span>
                                    </a>
                                </ng-template>
                            </li>
                        </ng-container>
                    </ul>
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>
    </mat-card-content>
</mat-card>